<template>
  <div id="app">

    <top-header></top-header>

    <transition name="fade">
      <div id="bean-container" class="bean-container" v-show="showBean">
        <div id="lottie"></div>
      </div>
    </transition>

    <transition name="fade-up" mode="out-in">
      <router-view/>
    </transition>

  </div>
</template>

<script>
import TopHeader from './components/TopHeader'
import beanman from './assets/bean-man'

export default {
  name: 'App',

  components: { TopHeader },

  data () {
    return {
      currentSection: 0
    }
  },

  metaInfo: {
    // if no subcomponents specify a metaInfo.title, this title will be used
    title: 'AuditLink',
    // all titles will be injected into this template
    titleTemplate: '%s - AuditLink'
  },

  watch: {
    $route () {
      if (this.$route.name === 'Contact') {
        beanman.switchPosition('phoneIn')
      } else if (this.$route.name === 'Home') {
        beanman.switchPosition('wave')
      } else if (this.$route.name === 'Services') {
        beanman.switchPosition('maglasIn')
      } else if (this.$route.name === 'Difference') {
        beanman.switchPosition('pointIn')
      } else if (this.$route.name === 'QuestionResult') {
        beanman.switchPosition('pointIn')
      } else {
        beanman.switchPosition('reset')
      }
    },

    '$root.$data.beanState' () {
      if (this.$root.$data.beanState === 'clipboard') {
        beanman.switchPosition('notepadIn')
        this.$root.$data.beanState = 'default'
      }
    },

    currentSection (t, v) {
      if (t === 1) {
        beanman.switchPosition('highFive')
      }
      if (t === 2) {
        beanman.switchPosition('tieIn')
      }
    }
  },

  methods: {
    initHomeScroll () {
      var h = Math.max(document.documentElement.clientHeight, window.innerHeight || 0)

      document.addEventListener('scroll', e => {
        const scroll = (document.documentElement && document.documentElement.scrollTop) || document.body.scrollTop

        if (scroll <= h) {
          this.currentSection = 0
        }

        if (scroll > h && scroll < (h * 1.5)) {
          this.currentSection = 1
        }

        if (scroll > (h * 1.5)) {
          this.currentSection = 2
        }
      })
    }
  },

  computed: {
    showBean () {
      // Define routes to hide the bean on here:
      if (this.$route.name === 'SingleService') {
        return false
      }
      if (this.$route.name === 'Approach') {
        return false
      }
      if (this.$route.name === 'About') {
        return false
      }
      if (this.$route.name === 'AboutSingle') {
        return false
      }
      if (this.$route.name === 'AboutDefault') {
        return false
      }
      return true
    }
  },

  mounted () {
    beanman.init()

    if (this.$route.name === 'Contact') {
      beanman.switchPosition('phoneIn')
    }
    if (this.$route.name === 'Home') {
      this.initHomeScroll()
      beanman.switchPosition('wave')
    }
    if (this.$route.name === 'Services') {
      beanman.switchPosition('maglasIn')
    }
    if (this.$route.name === 'Difference') {
      beanman.switchPosition('pointIn')
    }
    if (this.$route.name === 'QuestionResult') {
      beanman.switchPosition('pointIn')
    }
    if (this.$route.name === '404') {
      beanman.switchPosition('error')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue